import {
  SET_ACCOUNT_INFO,
  REMOVE_ACCOUNT_INFO,
  SET_LIST_PRICING,
  SET_S3_CREDENTIALS,
  SET_S3_BUCKET,
  SET_ACTIVE_PROJECT_NUMBER,
  SET_INACTIVE_PROJECT_NUMBER,
  SET_FIRST_AND_LAST_PROJECT
} from '@/store/mutation-types'
// import { getProjects } from '@/api/projects'
import { getTotalProjectByUser } from '@/api/system'
import { getS3Credentials } from '@/api/account'
import { getPricings, getPlans } from '@/api/payments'

const setAccountInfo = ({commit}, info = {}) => {
  commit(SET_ACCOUNT_INFO, info)
}

const removeAccountInfo = ({commit}) => {
  commit(REMOVE_ACCOUNT_INFO)
}

const setPricings = ({commit}, data) => {
  commit(SET_LIST_PRICING)
}

const fetchS3Token = ({commit}) => {
  getS3Credentials().then(response => {
    if (response.status === 1) {
      commit(SET_S3_CREDENTIALS, response.data)
      commit(SET_S3_BUCKET, response.bucket)
    }
  })
}

const setS3Credentials = ({commit}, data) => {
  commit(SET_S3_CREDENTIALS, data)
}

const setS3Bucket = ({commit}, bucket) => {
  commit(SET_S3_BUCKET, bucket)
}

const setActiveProjectNumber = ({commit}, value) => {
  commit(SET_ACTIVE_PROJECT_NUMBER, value)
}

const setInactiveProjectNumber = ({commit}, value) => {
  commit(SET_INACTIVE_PROJECT_NUMBER, value)
}

const checkTotalProjects = ({commit}) => {
  return new Promise((resolve, reject) => {
    getTotalProjectByUser().then((response) => {
      if (response.code === 200) {
        commit(SET_ACTIVE_PROJECT_NUMBER, response.data.opened)
        commit(SET_INACTIVE_PROJECT_NUMBER, response.data.closed)
        commit(SET_FIRST_AND_LAST_PROJECT, {first: response.data.first, last: response.data.latest})
        resolve(response.data)
      } else {
        reject(new Error('error in checkTotalProjects'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

const fetchPricings = ({commit}, locale) => {
  return new Promise((resolve, reject) => {
    getPricings({ locale }).then(response => {
      if (response.status === 1) {
        Promise.all(response.data.map((pricing, index) => {
          if (pricing.prod_id) {
            return new Promise((resolve) => {
              getPlans(pricing.prod_id).then(res => {
                if (res.status === 1) {
                  let planIndex = res.data.findIndex(item => item.interval === 'month')
                  pricing.plans = res.data
                  if (planIndex !== -1) {
                    pricing.plan = res.data[planIndex]
                  } else {
                    pricing.plan = res.data[0]
                  }
                  resolve(pricing)
                } else {
                  pricing.plan = undefined
                  pricing.plans = []
                  resolve(pricing)
                }
              })
            })
          } else {
            pricing.plan = undefined
            pricing.plans = []
            return pricing
          }
        })).then(values => {
          commit(SET_LIST_PRICING, values)
          resolve(values)
        })
      } else {
        reject(response.errors.message)
      }
    }).catch(error => {
      reject(error)
    })
  })
}

export default {
  setAccountInfo,
  removeAccountInfo,
  setPricings,
  setS3Credentials,
  setS3Bucket,
  setActiveProjectNumber,
  setInactiveProjectNumber,
  checkTotalProjects,
  fetchS3Token,
  fetchPricings
}



// WEBPACK FOOTER //
// ./src/components/account/store/actions.js